
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/versus/[slug]",
      function () {
        return require("private-next-pages/resources/versus/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/versus/[slug]"])
      });
    }
  